import React from "react"
import { Link } from "gatsby"
import styled from '@emotion/styled'

import Layout from "components/layout"
import SEO from "components/seo"
import { Container } from 'components/HomePage'
import Grid from 'components/Grid'
import CategorySection from 'components/CategorySection'
import CABtn from 'components/CABtn'
import { breakpoints} from 'utils/styles'
import BackBtn from 'components/BackBtn'

var slugify = require('slugify')

const Wrapper = styled.div`
	max-width: 920px;
	margin: 0 auto;
`

const CompanyCard = styled.div`
	margin: 2.5rem 0;
	position: relative;
	margin-bottom: 100px;
	h1 {
		font-family: 'Avenir Next';
		font-size: 1.7rem;
		margin-bottom: 10px;
	}
	@media (max-width: ${breakpoints.mobile}px) {
		padding-bottom: 50px;
	}
`

const BackgroundHeader = styled.div`
	position: relative;
    background-color:  #fff;
    max-height: 160px;
    overflow: hidden;
    text-align: center;
    border-radius: 4px;
    margin-bottom: 20px;
    background-image: ${props=>props.img};
    background-size: auto 40px;
    &:before {
	    display: block;
	    content: "";
	    width: 100%;
	    padding-top: 100%;
	}
`

const Category = styled.div`
  font-size: 0.9rem;
  color: rgb(0, 0, 0, 0.6);
  margin-bottom: 20px;
`

const TagBtn = styled.a`
  border: 1px solid rgb(0, 0, 0, 0.2);
  padding: 8px 12px;
  border-radius: 4px;
  max-width: 160px;
  display: inline-flex;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-size: .8rem;
  color: rgb(0, 0, 0, 0.8);
  align-items: center;
  margin-bottom: 5px;
  margin-right: 5px;
  transition-duration: 0.2s;
  svg {
  	height: 20px;
  	margin-left: 5px;
  }
  @media (max-width: ${breakpoints.mobile}px) {
  	min-width: 0;
  	width: 100%;
  	align-items: center;
  	justify-content: center;
  	font-size:1rem;
  	padding: 10px 8px;
  	max-width: 100%;
  	svg {
	  	height: 15px;
	  	margin-left: 3px;
	  }
  }
  &:hover {
  	border: 1px solid rgb(0, 0, 0, 0.5);
  }
`

const RelatedBox = styled.div`
	margin: 100px 0;
	padding: 50px 20px;
	border: 1px solid rgba(0,0,0,.05);
	h4 {
		margin-left: 15px;
	}
`

const LinkRow = styled.div`
	width: 100%;
`

const Arrow = () => (
	<svg width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
	  <path stroke="none" d="M0 0h24v24H0z"/>
	  <line x1="17" y1="7" x2="7" y2="17" />
	  <polyline points="8 7 17 7 17 16" />
	</svg>
)

const Email = () => (
	<svg width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  		<path stroke="none" d="M0 0h24v24H0z"/>
	 	<rect x="3" y="5" width="18" height="14" rx="2" />
	  	<polyline points="3 7 12 13 21 7" />
	</svg>
)


const validateEmail = (email) => {
  var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email);
}

const LinkButton = ({link, name}) => {
	var isEmail;
	if (!link) return <div/>
	if (validateEmail(link)) {
		link = `mailto:${link}`
		isEmail = true;
	}
	return (
		<TagBtn href={link} target="_blank">
			{name}
			{isEmail ? <Email/> :<Arrow/>}
		</TagBtn>
	)
}

const CategoryPage = ({
	data: { googleSheetCompaniesRow },
	pageContext: { categories, company, related, relatedCategories, type },
	...props
}) => {
	const c = googleSheetCompaniesRow
	return (
		<Layout>
		    <SEO title={`Access your data from ${c.name}`} />
		    <Wrapper>
		    	<CompanyCard>
		    		<BackBtn/>
		    		<BackgroundHeader img={`url(/icons/${c.logo})`}/>
					<h1>Access your data from {c.name}</h1>
					<Link to={`/categories/${slugify(c.companytype.toLowerCase())}`}><Category>{c.companytype}</Category></Link>
					<LinkRow>
					<LinkButton link={c.access} name="Access"/>
					<LinkButton link={c.delete} name="Delete"/>
					<LinkButton link={c.donotsell} name="Do not sell"/>
					</LinkRow>
					<CABtn ca={c.californiaonly} full/>
				</CompanyCard>
			
				{Object.keys(relatedCategories).map((c)=> {
                        if (relatedCategories[c].length) {
                            return <CategorySection title={c} companies={relatedCategories[c]} />
                        }
                    })}
			</Wrapper>
		</Layout>
	)
 
}

export const pageQuery = graphql`
	query($id: String!) {
	    googleSheetCompaniesRow(name: { eq: $id }) {
	        id
	        name
	        info
	        logo
	        access
	        delete
	        donotsell
	        californiaonly
	        companytype
	    }
	}
`

export default CategoryPage
